import { createFileRoute } from '@tanstack/react-router';
import { SSettings } from '@/screens/SSettings/SSettings';

const SECTIONS = ['profile', 'users', 'groups', 'roles', 'org', 'audit'] as const;
type Section = (typeof SECTIONS)[number];

export const Route = createFileRoute('/$orgId/settings')({
  component: SSettings,
  validateSearch: (raw: Record<string, unknown>): { section?: Section } => {
    const s = typeof raw.section === 'string' ? raw.section : undefined;
    return {
      section: SECTIONS.includes(s as Section) ? (s as Section) : undefined,
    };
  },
});
